"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingView = void 0;
var React = require("react");
var recoil_1 = require("recoil");
var lib_1 = require("typestyle/lib");
var GridOn_1 = require("../icons/GridOn");
var PhotoSizeSelectLarge_1 = require("../icons/PhotoSizeSelectLarge");
var Undo_1 = require("../icons/Undo");
var recoils_1 = require("../recoils");
var undoEditing_1 = require("../utils/undoEditing");
var IconButton_1 = require("./IconButton");
var Paper_1 = require("./Paper");
var ResizeDialog_1 = require("./ResizeDialog");
var cn = {
    root: lib_1.style({
        paddingTop: 16,
        paddingRight: 16
    }),
    container: lib_1.style({
        display: 'flex',
        alignItems: 'center',
        height: 56,
        minWidth: 120
    }),
    fripVert: lib_1.style({
        transform: 'scaleY(-1)'
    })
};
function SettingView() {
    var _a = __read(recoil_1.useRecoilState(recoils_1.debugState), 2), debug = _a[0], setDebug = _a[1];
    var toggleDebug = React.useCallback(function () {
        setDebug(function (debug) { return !debug; });
    }, []);
    var setEditing = recoil_1.useSetRecoilState(recoils_1.editingState);
    var undo = React.useCallback(function () {
        setEditing(function (current) { return undoEditing_1.undoEditing(current); });
    }, []);
    var undoPatches = recoil_1.useRecoilValue(recoils_1.undoPatchesState);
    var _b = __read(React.useState(false), 2), openResize = _b[0], setOpenResize = _b[1];
    return (React.createElement("div", { className: cn.root },
        React.createElement(Paper_1.Paper, { className: cn.container },
            React.createElement(IconButton_1.IconButton, { label: "\u3082\u3069\u3059", margin: true, disabled: undoPatches.length === 0, onClick: undo },
                React.createElement(Undo_1.default, null)),
            React.createElement(IconButton_1.IconButton, { active: debug, label: "\u306F\u3093\u3066\u3044", margin: true, onClick: toggleDebug },
                React.createElement(GridOn_1.default, null)),
            React.createElement(IconButton_1.IconButton, { label: "\u30B5\u30A4\u30BA", margin: true, onClick: function () {
                    setOpenResize(true);
                } },
                React.createElement(PhotoSizeSelectLarge_1.default, { className: cn.fripVert }))),
        openResize ? (React.createElement(ResizeDialog_1.ResizeDialog, { open: true, onClose: function () { return setOpenResize(false); } })) : null));
}
exports.SettingView = SettingView;
//# sourceMappingURL=SettingView.js.map